import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { langHash } from './assets.hash';

/**
 * A specific translate loader that tries to consider the language files hash code, so we don't face problems with
 * client side caches.
 */
class HashedTranslateHttpLoader implements TranslateLoader {
	private http: HttpClient;
	private prefix: string;
	private suffix: string;

	public constructor(http: HttpClient, prefix?: string, suffix?: string) {
		this.http = http;
		this.prefix = prefix;
		this.suffix = suffix;
	}

	public getTranslation(lang: string): Observable<Record<string, any>> {
		const fileName = `${this.prefix}${lang}${this.suffix}`;
		return this.http.get(`${fileName}?v=` + langHash(lang)).pipe(
			map(function (res) {
				return res;
			})
		);
	}
}

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
	return new HashedTranslateHttpLoader(http, './assets/i18n/', '.json');
}
